var _a;
/* eslint-disable no-param-reassign */
import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { PaymentMethod, PaymentFrequency } from './financialCalculators';
export var initialState = {
    name: 'default',
    paymentOptions: {
        paymentMethod: PaymentMethod.lease,
        paymentFrequency: PaymentFrequency.monthly,
        termAndRate: 48,
    },
    paymentMethodDefaults: (_a = {},
        _a[PaymentMethod.finance] = {
            term: 84,
            frequency: PaymentFrequency.monthly,
        },
        _a[PaymentMethod.lease] = {
            term: 48,
            frequency: PaymentFrequency.monthly,
        },
        _a[PaymentMethod.cash] = {
            term: 0,
            frequency: PaymentFrequency.monthly,
        },
        _a),
};
export var brandNameDetected = createAction('brandConfig/brandNameDetected');
export var defaultPaymentOptionsDetected = createAction('brandConfig/defaultPaymentOptionsDetected');
export var defaultPaymentMethodOptionsDetected = createAction('brandConfig/defaultPaymentMethodOptionsDetected');
var brandConfig = createReducer(initialState, function (builder) {
    builder
        .addCase(brandNameDetected, function (state, action) {
        state.name = action.payload;
    })
        .addCase(defaultPaymentOptionsDetected, function (state, action) {
        state.paymentOptions = action.payload;
    })
        .addCase(defaultPaymentMethodOptionsDetected, function (state, action) {
        state.paymentMethodDefaults = action.payload;
    });
});
export var selectBrandConfig = createSelector(function (state) { return state.brandConfig.name; }, function (state) { return state.brandConfig.paymentOptions; }, function (state) { return state.brandConfig.paymentMethodDefaults; }, function (name, paymentOptions, paymentMethodDefaults) { return ({ name: name, paymentOptions: paymentOptions, paymentMethodDefaults: paymentMethodDefaults }); });
export var selectDefaultTerm = createSelector(function (state, paymentMethod) {
    return state.brandConfig.paymentMethodDefaults[paymentMethod].term;
}, function (term) { return term; });
export var selectDefaultPaymentFrequency = createSelector(function (state, paymentMethod) {
    return state.brandConfig.paymentMethodDefaults[paymentMethod].frequency;
}, function (frequency) { return frequency; });
export default brandConfig;
